import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

export const ObservedHolidays = {
    NEW_YEARS_DAY: "New Year's Day",
    NEW_YEARS_DAY_SUBSTITUTE: "New Year's Day (substitute day)",
    MEMORIAL_DAY: 'Memorial Day',
    INDEPENDENCE_DAY: 'Independence Day',
    INDEPENDENCE_DAY_SUBSTITUTE: 'Independence Day (substitute day)',
    LABOR_DAY: 'Labor Day',
    THANKSGIVING_DAY: 'Thanksgiving Day',
    CHRISTMAS_DAY: 'Christmas Day',
    CHRISTMAS_DAY_SUBSTITUTE: 'Christmas Day (substitute day)',
} as const;

export const formatHour = (hour: number) =>
    dayjs().tz('America/New_York').hour(hour).minute(0).second(0).tz().format('LT');
